module.exports = __webpack_public_path__ + "img/leg.3a7f6157.png";